// extracted by mini-css-extract-plugin
export default {"sectionNav":"section-nav__sectionNav___1LgAN","attachToPrimaryNav":"section-nav__attachToPrimaryNav___TffVt","isActive":"section-nav__isActive___3ObLg"};